module.exports = __webpack_public_path__ + "img/va.vacf15a64.svg";